jQuery(function($) {
	$('.vote-button').on('click', function () {
		$('.taste-vote').html($(this).data('taste')); //Data value
		$('.voted-image').attr('src', ($(this).data('image'))); //Pass image from front-page sillkampen
		$('.voted-container-second').css('background', $(this).data('background')); //Pass background color
		$('.percentage-container-second').html($(this).data('percentage'));
	
		$(this).parent().find('input[type=radio]').prop("checked", true);
	});

	$('.vote-type-button').on('click', function () {
		$(this).parent().find('input[type=radio]').prop("checked", true);
	});
});


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/scripts/pages/sillkampen.js
// module id = 31
// module chunks = 0